module.exports = __webpack_public_path__ + "media/azelaic-large.5fe6587a.mp4";